export interface NavSubPage {
  title: string;
  href: string;
  isNew?: boolean;
}

export interface NavPage {
  id: string;
  title: string;
  href?: string;
  items?: NavSubPage[];
}

export interface NavigationPages {
  main: NavPage[];
}

const pages: NavigationPages = {
  main: [
    // {
    //   title: 'topbar.pages.company.main',
    //   href: '/',
    // },
    {
      id: 'nav-products',
      title: 'topbar.pages.products',
      href: '/products/50,51',
    },
    {
      id: 'nav-certificates',
      title: 'topbar.pages.support.certificates',
      href: '/certificates',
    },
    {
      id: 'nav-distributors',
      title: 'topbar.pages.support.whereToBuy',
      href: '/distributors',
    },
    // {
    //   title: 'topbar.pages.support',
    //   id: 'support',
    //   items: [
    //     { title: 'topbar.pages.support.certificates', href: '/certificates' },
    //     { title: 'topbar.pages.support.whereToBuy', href: '/distributors' }
    //   ],
    // },
    {
      id: 'nav-contact',
      title: 'topbar.pages.company.contactUs',
      href: '/contact',
    },
    {
      id: 'nav-blog',
      title: 'topbar.pages.blog',
      href: '/blog',
    },
  ],
};

export default pages;
